import { call, put } from 'redux-saga/effects';
import { fetchVPOCombinedActionsSuccess, fetchVPOCombinedActionsFailure, FetchVPOCombinedActionsRequest } from './actions';
import { getVPOCombinedActions } from '../../api/api';

export function* fetchVPOCombinedActionsSaga(action: FetchVPOCombinedActionsRequest) {
  try {
    const { filters, append } = action.payload;
    const response: any = yield call(getVPOCombinedActions, filters);
    if (response.success) {
      yield put(fetchVPOCombinedActionsSuccess(response, append));
    } else {
      yield put(fetchVPOCombinedActionsFailure(response.message || 'Ошибка загрузки'));
    }
  } catch (error: any) {
    console.error('Saga ошибка:', error);
    yield put(fetchVPOCombinedActionsFailure(error?.message || 'Ошибка сети'));
  }
}